<p-toolbar>
  <app-header-text-icon (toggleChange)="toggleChange.emit($event)"></app-header-text-icon>
  <div class="p-toolbar-group-end">
    @if (displayToggleFeature) {
      <app-toggle-feature></app-toggle-feature>
    }
    <app-header-menu-logged />
  </div>
</p-toolbar>